import { useEffect, useState } from "react"
import { Settings } from "lucide-react"
import StateConstants from "src/states/StateContstants"

export function emailInitial(email: string | null | undefined): string | null {
    const initial = email?.trim().charAt(0)
    return initial ? initial.toUpperCase() : null
}

export default function AccountAvatar({ stateHandler, onClick }: { stateHandler: any, onClick: () => void }) {
    const [email, setEmail] = useState<string | null>(stateHandler.get(StateConstants.USER_EMAIL) ?? null)

    useEffect(() => {
        let mounted = true
        stateHandler.addListener(StateConstants.USER_EMAIL, (value: string | null) => {
            if (mounted) setEmail(value ?? null)
        })
        return () => { mounted = false }
    }, [stateHandler])

    const initial = emailInitial(email)
    const label = email ? `Account: ${email}` : "Account settings"
    return (
        <button
            className={"landing-settings-button" + (initial ? " landing-account-avatar" : "")}
            type="button"
            onClick={onClick}
            aria-label={label}
            title={email ?? "Account settings"}
        >
            {initial ? <span aria-hidden>{initial}</span> : <Settings size={18} strokeWidth={1.9} aria-hidden />}
        </button>
    )
}
